<template>
    <div>
        <!--show refresh button-->
        <search-bar @search_event="searchEvent"
                    @refresh_event="requestResults"
                    :prev_filter_string="prev_filter_string"
                    :title="title"
                    :bookmark="bookmark"></search-bar>

        <!--new filter options-->
        <div v-if="filters.toggle_active"
             class="d-flex  justify-content-start align-items-center"
        >
            <div v-on:click="filters.show_options = !filters.show_options">
                <i class="material-icons">filter_list</i>
            </div>
            <div v-if="filters.show_options" class="d-flex justify-content-between align-items-center">

                <template v-for="key in columns" class="btn btn-primary">
                    <div v-if="getFilterOptions(key).type == 'date'" class="p-3">
                        <div
                                v-on:click="filterOptionSelect(key)"
                                :data-component-key="key"
                                :data-component-reference_field="getFilterOptions(key).reference_field"
                                :data-component-type="getFilterOptions(key).type"
                                class="text-uppercase mb-3">{{key}}
                        </div>

                        <div v-if="types[key].active == true"
                             class="d-flex justify-content-between align-items-center">

                            <div class="md-form">
                                <input type="date" :id="'date_start--'+key" class="form-control">
                                <label :for="'date_start--'+key" class=" active">from</label>
                            </div>
                            <div class="md-form">
                                <input type="date" :id="'date_end--'+key" class="form-control">
                                <label :for="'date_end--'+key" class=" active">to</label>
                            </div>
                        </div>

                    </div>
                </template>
            </div>
        </div>
        <!--oe new filter-->
        <div id="table--search"
             class="">
            <table class="table table--search-table"
                   v-if="filteredItems.length"
                   style="font-variant-numeric: lining-nums tabular-nums;"
            >
                <thead class="">
                <!--hide headers from small view-->
                <tr class="table-primary d-none d-md-table-row">
                    <template v-for="key in columns"
                    >
                        <th v-on:click="sortBy(key)"
                            v-if="canFilterField(key)"
                            :class="setCellType(key)"
                            :key_ref="key"
                        >
                            <!--{{debug(key)}}-->
                            <div class="d-flex  align-items-center"
                                 :class="setCellType(key,true)">
                                <!--flex-grow-1-->
                                <!--{{debug(key)}}-->
                                <div class="">
                                    <div v-if="key == 'category'"
                                         class="d-flex justify-content-start align-items-center">
                                        <i class="d-md-none d-flex material-icons mr-2">filter_list</i>
                                        <span class="d-none d-md-flex">{{ key | capitalize }}</span>
                                    </div>
                                    <div v-else-if="key == 'id'">
                                        {{ key | lowercase }}
                                    </div>
                                    <div v-else class="text-capitalize">
                                        {{ key | capitalize }}
                                    </div>
                                </div>
                                <!--sort filters-->
                                <i
                                        class="material-icons"
                                >
                                    <template v-if="sortOrders[key] > 0">arrow_drop_up</template>
                                    <template v-else-if="sortOrders[key] < 0">arrow_drop_down</template>
                                    <template v-else>unfold_more</template>
                                </i>
                            </div>
                        </th>
                        <th v-else class="text-center">
                            {{ key | capitalize }}
                        </th>
                    </template>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in filteredItems" class="card z-depth-1 mb-2 d-md-table-row bg-level-4">
                    <!--info cells-->
                    <td class="py-0 py-md-1 d-flex d-md-table-cell justify-content-between align-items-center"
                        v-for="key in columns"
                        :data-key="key"
                        :class="[
                            setCellType(key),
                                {
                                    'fs-md-inherit': type_in_array(key, ['slug', 'string','title','json','status'])===true,

                                    'py-md-0 p-md-2':type_in_array(key, ['icon','slug','category','string','title','json','status','date','date_time','datetime','time'])===true,

                                    'old--d-inline-flex': type_in_array(key, ['id','money','category','icon','date','date_time','datetime','time','status'])===true,

                                    'text-right':type_in_array(key, ['money'])===true,

                                    'text-md-nowrap ':type_in_array(key, ['slug','title'])===true,

                                    'fs-3': type_in_array(key, ['title'])===true,
                                }
                            ]"
                    >
                        <!--mobile view reference-->
                        <span class="d-block d-md-none text-muted"
                              :class="{
                                'text-lowercase':type_in_array(key, ['id'])===true,
                                'text-capitalize':type_in_array(key, ['id'])!==true,
                            }"
                        >{{key}}:</span>

                        <!--the values of the fields-->
                        <!--type="icon"-->
                        <template data-element-type="icon"
                                  :data-value="item[key]"
                                  v-if="types[key].type == 'icon'"
                        >
                            <i v-if="isMaterialIcon(item[key]) === true"
                               class="material-icons"
                               :class="'table--'+types[key].type"
                               :data-element-type="types[key].type"
                            >{{readIconContent(item[key])}}</i>

                            <i v-else
                               class="fa icon"
                               :class="[readIconClass(item[key],item),'table--'+types[key].type]"
                               :data-element-type="types[key].type"
                            ></i>
                        </template>

                        <!--type="category"-->
                        <template data-element-type="category"
                                  :data-value="item[key]"
                                  v-else-if="types[key].type == 'category'"
                        >

                            <code data-element-type="category"
                                  :class="'table--'+types[key].type"

                                  :data-value="item[key]"
                                  class="text-nowrap">{{item[key]}}</code>
                        </template>

                        <!--type="date"-->
                        <span data-element-type="date"
                              class="text-nowrap"
                              :data-value="item[key]"

                              :class="'table--'+types[key].type"
                              v-else-if="types[key].type == 'date'"
                        >
                                {{item[key]}}
                        </span>

                        <!--type="date_time"-->
                        <span data-element-type="date_time"
                              class="text-nowrap"
                              :data-raw="item[key]"

                              :class="'table--'+types[key].type"
                              v-else-if="types[key].type == 'date_time'"
                        >
                                {{getDate(item[key],types[key].type)}}
                        </span>

                        <!--ent-type="number"-->
                        <template data-element-type="number"
                                  :data-value="item[key]"
                                  v-else-if="types[key].type == 'number'"
                        >
                            {{item[key]}}
                        </template>

                        <!--type="slug"-->
                        <template data-element-type="slug"
                                  :data-value="item[key]"
                                  v-else-if="types[key].type == 'slug'"
                        >

                            <code data-element-type="slug"
                                  :data-value="item[key]"

                                  :class="'table--'+types[key].type"
                                  class="text-nowrap">{{item[key]}}</code>
                        </template>

                        <!--type="json"-->
                        <template data-element-type="json"

                                  v-else-if="types[key].type == 'json'"
                        >
                            <BaseJsonView :json_counter="0"
                                          :json="getJson(item[key])"
                                          class="px-2 bg-dark"
                                          :class="'table--'+types[key].type"
                            ></BaseJsonView>

                        </template>

                        <!--type == 'money'-->
                        <template :data-element-type="'money['+item[key]+']'"
                                  v-else-if="types[key].type == 'money'">
                                <span v-if="item[key]!=''"
                                      :data-element-type="types[key].type"
                                      :class="'table--'+types[key].type"
                                      :data-value="item[key]"
                                      class="money currency-sign text-right text-nowrap"
                                >

                                    <span>{{item[key]}}</span>
                                </span>
                            <span v-else
                                  :class="'table--'+types[key].type"
                            > - </span>
                        </template>

                        <template v-else-if="types[key].type == 'status'">
                            <!--type="status"-->
                            <code v-if="status_url ===null"
                                  data-element-type="status"
                                  class="text-nowrap"
                                  :data-value="item[key]"

                                  :class="[
                                  {
                                    'disabled':item[key] === 'inactive'
                                  },
                                  'table--'+types[key].type

                                  ]">{{item[key]}}
                            </code>
                            <base-switch-events
                                    v-else
                                    :tabindex="0"
                                    class="flex align-items-end align-items-md-start"

                                    :row="false"
                                    :status="item[key]"
                                    field="status"
                                    identifier="set_status"
                                    switch_off="off"
                                    switch_on="on"
                                    @status_change="(value)=>{
                                        updateStatus(item,key,value)
                                    }"
                                    title="Quick set status"
                            ></base-switch-events>
                        </template>
                        <!--finally not met conditions so treat as a string-->
                        <!--type="string"-->
                        <span data-element-type="id"
                              class="d-flex  justify-content-start align-items-center"
                              :class="'table--'+types[key].type"
                              v-else-if="types[key].type == 'id'"
                        >
                                {{item[key]}}
                            </span>

                        <span v-else data-element-type="string">
                                {{item[key]}}
                            </span>
                    </td>
                    <!--action cells-->
                    <td class="">
                        <!--<hr class="d-md-none">-->
                        <div class=" d-flex justify-content-center justify-content-md-center align-items-center">
                            <template
                                    v-for="crud in ['read']"
                                    v-if="crud_route_exists('read','update','delete')"
                            >
                                <BaseIconButton
                                        v-if="hasRoutePattern(crud,item)"
                                        :float="true"
                                        class="btn-primary"
                                        :route="crud_route(crud,item)"
                                        :icon="{
                                            content:crud_route_icon(crud)
                                        }"
                                        tag_name="a"
                                ></BaseIconButton>

                                <BaseIconButton
                                        v-else
                                        :float="true"
                                        class="btn-primary"
                                        @click_event="crud_route(crud,item)"
                                        :icon="{
                                            content:crud_route_icon(crud)
                                        }"
                                        tag_name="div"
                                ></BaseIconButton>
                            </template>
                        </div>
                        <!--<hr class="d-md-none">-->
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import {route as laravel_route, getUrl} from '../../../../../app/Shared/Resources/Assets/js/helpers/routes';
    import {format as formatMoney} from '../../helpers/money';
    import {_} from 'underscore';
    // import {sort} from 'underscore.string';
    import {
        getDate as formatDate,
        DATE_FORMAT
    } from '../../../../../app/Shared/Resources/Assets/js/helpers/format.date';
    // add imports here

    Vue.component('search-bar', require('../../../../../app/Shared/Resources/Assets/js/components/SearchBar'));

    /**
     * Creates a table
     * props required
     */
    export default {
        /**
         *
         * */
        props: {
            bookmark: {
                type: Object,
                default: () => {
                }
            },
            prev_filter_string: {
                type: String,
                default: ''
            },
            status_url: {
                type: String,
                default: null
            },
            title: String,
            request_route_url: String,
            laravel_route_uri: String,
            /**
             * @namespace
             * @property {string}                           {crud_type}                             - read action
             * @property {string}                           {crud_type}.route                       - defines the route name to be requested (not the url)
             * @property {object}   [{crud_type}.params]    {crud_type}.params                      - contains params passed to route
             * @property {array}                            {crud_type}.params.refs                 - contains array of key params
             * @property {boolean}  [{crud_type}.emit]      {crud_type}.emit                        - if true will emit instead of request uri
             * @property {string}   [{crud_type}.icon]      {crud_type}.icon                        - icon used for button
             */
            crud: {},
            emit_crud: null,
            reload: false
        },
        watch: {
            types: function (prev, obj) {
                // console.log('types', prev, obj);
            },
            reload: function (newVal) {
                if (newVal == true) {
                    this.requestResults();
                }
            }
        },
        created() {
        },
        mounted() {
            let self = this;

            /**
             * @param {{emit_table_event_key_prop:string}} is an optional prop to be used as emit key
             */
            if (typeof this.emit_table_event_key_prop !== 'undefined' && this.emit_table_event_key_prop !== null) {
                this.emit_table_event_key = this.emit_table_event_key_prop;
            }

            this.requestResults().then(function () {
                //                console.log('requestResults', 'self.prev_filter_string', self.prev_filter_string);
                if (self.prev_filter_string != '') {
                    self.searchEvent(self.prev_filter_string);
                }
            });

        },
        data: function () {

            return {
                button_classes: 'btn-floating mr-2 cursor-pointer',
                restricted_filters: ['json', 'icon'],
                items: [],
                columns: [],

                filters: {
                    toggle_active: false,
                    show_options: true
                },
                display_limit: 10,
                /**
                 * @param types[].reference_field   defines true or false for the parent key
                 * @var {Array[]} types defines the record style and processing
                 */
                types: [],
                searchQuery: String,
                search: '',
                sortKey: '',
                emit_table_event_key: 'emit_table_event',
                sortOrders: {},
                crudTypeIcons: {
                    create: 'create',
                    read: 'pageview',
                    update: 'update',
                    delete: 'delete'
                },
            };
        },
        methods: {
            updateStatus(item, key, status) {

                let self = this;
                let id = item.id;

                let axios_data = {
                    id: id,
                    status: (status === 'active')
                };

                axios
                    .post(self.status_url, axios_data)
                    /**
                     * @param {Object} response
                     */
                    .then(function (response) {
                        item[key] = status;
                        self.items[id] = item;
                        window.location.reload();
                    })
                    .catch(function (e) {
                        // catch error if any
                        //console.error('table_search fetch', e);
                    })
                    .then(function () {
                        // always executed
                    });
            },
            statusRequest(id, status) {
                let self = this;

                let axios_data = {
                    id: id,
                    status: status
                };

                axios
                    .post(self.status_url, axios_data)
                    /**
                     * @param {Object} response
                     */
                    .then(function (response) {
                        //console.log('axios response', response);
                    })
                    .catch(function (e) {
                        // catch error if any
                        //console.error('table_search fetch', e);
                    })
                    .then(function () {
                        // always executed
                    });
            },
            type_in_array(key, arrayList) {
                //                console.log('type_in_array',
                //                    key,
                //                    this.types[key].type,
                //                    (
                //                        arrayList.indexOf(this.types[key].type) > -1
                //                    ),
                //                    arrayList);
                return (
                    arrayList.indexOf(this.types[key].type) > -1
                );
            },
            canFilterField(field) {
                let theField = this.types[field];

                if (_.isUndefined(theField) || theField == null) {
                    return true;
                }
                if (_.isUndefined(theField.type) || theField.type == null) {
                    return true;
                }
                //                console.log('canFilterField',field, ' this.types', this.types);

                return (
                    this.restricted_filters.indexOf(theField.type) <= -1
                );
            },
            stringToObject(stringItem) {
                return typeof stringItem === 'string' || stringItem instanceof String ? JSON.parse(stringItem)
                    : stringItem;
            },
            isMaterialIcon(icon) {
                if (this.stringToObject(icon).hasOwnProperty('fa')) {
                    return false;
                }
                return true;
            },
            readIconClass(icon_raw, key) {
                let icon = this.stringToObject(icon_raw);
                //                console.log('readIconClass','key',key, 'icon',icon);
                if (icon.hasOwnProperty('fa')) {
                    return icon.icon;
                } else {
                    return 'material-icons';
                }
            },
            readIconContent(icon) {
                if (icon.hasOwnProperty('fa')) {
                    return '';
                } else {
                    return icon.icon;
                }
            },
            /**
             * return the flex alignment type
             * @param item
             */
            readHeaderType(item) {
                switch (this.types[item].type) {

                }
            },
            setCellType(item, header) {
                let type = this.types[item].type;
                // console.log('type',type);
                //                console.log('setCellType', 'this.types[item]',this.types[item]);
                switch (type) {
                    case 'title':
                        if (header == true) {
                            return '';
                        }
                        //                        return 'text-center text-nowrap';
                        return 'text-left w-md-50 w-100';
                    case 'id':
                        if (header == true) {
                            return '';
                        }
                        return 'text-left';
                    case 'number':
                        if (header == true) {
                            return '';
                        }
                        return 'text-left';

                    case 'money':
                        if (header == true) {
                            return 'justify-content-end';
                        }
                        return 'text-right';

                    case 'icon':
                        if (header == true) {
                            return '';
                        }
                        //                        return 'text-center text-nowrap';
                        return 'text-center';

                    case 'category':
                        if (header == true) {
                            return '';
                        }
                        return 'text-left text-lowercase font-weight-light';

                    case 'date':
                        if (header == true) {
                            return '';
                        }
                        //                        return 'text-center text-nowrap';
                        return 'text-left';

                    case 'date_time':
                        if (header == true) {
                            return '';
                        }
                        //                        return 'text-center text-nowrap';
                        return 'text-left';

                    case 'time':
                        if (header == true) {
                            return '';
                        }
                        //                        return 'text-center text-nowrap';
                        return 'text-right';

                    case 'datetime':
                        if (header == true) {
                            return '';
                        }
                        //                        return 'text-center text-nowrap';
                        return 'text-right';

                    case 'status':
                        if (header == true) {
                            return '';
                        }
                        //                        return 'text-center text-nowrap';
                        return 'text-center';

                    case 'json':
                        if (header == true) {
                            return '';
                        }
                        //                        return 'text-center text-nowrap';
                        return 'text-left w-md-50 w-100';
                }
                return '';
            },
            getJson(data) {
                //                console.log('getJson', 'data',data);
                return data;
                //              return JSON.parse(data);
            },
            dateFormat(format) {
                if (format == 'date_time') {
                    return DATE_FORMAT.date_time.short;
                }
                return DATE_FORMAT.tiny;
            },
            getDate(date, format) {
                /**
                 <!--cannot do this from here-->
                 <!--search would have to take into account this pattern-->
                 <!--i don't think the overheads are worth it-->
                 return formatDate(date, this.dateFormat(format));
                 * */
                return date;
            },
            getMoney(price) {
                /**
                 <!--cannot do this from here-->
                 <!--search would have to take into account this pattern-->
                 <!--i don't think the overheads are worth it-->
                 let item = formatMoney(price);
                 * */
                let item = price;
                // console.log('getMoney', 'item', item);
                return item;
            },
            filterOptionSelect(column) {
                this.filterOptionActive(column);

                this.types[column].active = !this.types[column].active;
                // console.log('filterOptionSelect','column', 'this.types[column].active',this.types[column].active);
                // console.log('filterOptionSelect', 'this.types[column].active', this.types[column].active);
                return this.types[column].active;
            },
            filterOptionActive(column) {
                if (!this.types[column].hasOwnProperty('active')) {
                    this.types[column]['active'] = false;
                    // console.log('filterOptionActive', 'false',false);
                    return false;
                }
                // console.log('filterOptionActive', 'this.types[column].active',this.types[column].active);
                return this.types[column].active;
            },
            getFilterOptions(column) {
                if (!this.types[column].hasOwnProperty('active')) {
                    this.types[column]['active'] = false;
                    // console.log('getFilterOptions', 'x',this.types[column]['active']);
                }
                // console.log('getFilterOptions', 'this.types[column]',this.types[column]);

                // find the column actions in types
                return this.types[column];
                // switch (columnType) {
                // 	case 'string':
                //         return ['asc','desc'];
                // 	case 'date':
                // 		// return date range option
                // }

            },
            requestResults() {
                let data = {}, _this = this;

                return axios.post(this.request_route_url, data)
                    .then(function (response) {
                        /**
                         [
                         'data'    => $sales,
                         'columns' => [
                         'date',
                         'paid',
                         'refunded',
                         'sale',
                         ],
                         'types'   => [
                         'date'      => [
                         'reference_field' => 'date',
                         'type'            => 'date'
                         ],
                         'paid'      => [
                         'reference_field' => 'paid',
                         'type'            => 'string'
                         ],
                         'refunded'      => [
                         'reference_field' => 'refunded',
                         'type'            => 'string'
                         ],
                         'sale'      => [
                         'reference_field' => 'sale',
                         'type'            => 'string'
                         ],
                         ]
                         ]
                         */
                        if (response.data.success) {
                            if ('columns' in response.data.result) {
                                _this.columns = response.data.result.columns;
                            }
                            if ('types' in response.data.result) {
                                _this.types = response.data.result.types;
                                // console.log('_this.types', _this.types);
                            }
                            if ('data' in response.data.result) {
                                _this.items = response.data.result.data;
                            } else {
                                _this.items = response.data.result;
                            }
                            // let sortOrders = {};
                            _this.columns.forEach(function (key) {
                                // console.log('key',key);
                                _this.sortOrders[key] = 0;
                            });
                            _this.$emit(_this.emit_table_event_key, {
                                'action': 'table_reloaded'
                            });
                        }
                    })
                    .catch(function (e) {
                        console.error(e);
                    });
            },
            crud_route_icon(crud_type) {
                let icon = '';

                try {
                    if (!crud_type in this.crudTypeIcons) {
                        throw 'crud type not valid' + 'crud:' + crud_type;
                    }
                    if ('icon' in this.crud[crud_type]) {
                        icon = this.crud[crud_type].icon.trim();
                        if (icon == '') {
                            icon = this.crudTypeIcons[crud_type];
                        }
                    } else {
                        icon = this.crudTypeIcons[crud_type];
                    }
                } catch (e) {
                    console.error('e', e);
                }
                return icon;
            },
            hasRoutePattern(crud_type) {
                return (
                        typeof this.crud[crud_type].pattern !== 'undefined' && this.crud[crud_type].pattern !== null
                    )
                    && (
                        typeof this.crud[crud_type].route !== 'undefined' && this.crud[crud_type].route !== null
                    );

            },
            /**
             * Route must a laravel route not a uri.
             * @param crud_type
             * @param item    the parameter row used in the route if any
             * @returns {string|null}
             */
            crud_route(crud_type, item) {

                try {
                    if (!crud_type in this.crudTypeIcons) {
                        throw 'crud type not valid' + 'crud:' + crud_type;
                    }
                    let paramsData = this.createRoutePrams(crud_type, item);
                    //console.log('crud_route', 'paramsData',paramsData);
                    // is this an emit?
                    if (typeof this.crud[crud_type].emit !== 'undefined' && this.crud[crud_type].emit !== null) {
                        if (this.crud[crud_type].emit == true) {
                            this.$emit(this.emit_table_event_key, {
                                'action': crud_type,
                                'id': item.id
                            });
                            return null;
                        } else {
                            /**
                             * @param string route_name
                             * @param Object params
                             * @callback anonymous callback
                             */
                            laravel_route(this.laravel_route_uri, paramsData, function (data) {
                                window.location.href = data;
                            });
                        }
                    }

                    // we have a route path uri and a pattern
                    else if (this.hasRoutePattern(crud_type)) {
                        //                        console.log('crud_route', 'paramsData', paramsData);
                        return getUrl(this.crud[crud_type].pattern, paramsData.params);
                    }
                    /**
                     * @param string route_name
                     * @param Object params
                     * @callback anonymous callback
                     */
                    laravel_route(this.laravel_route_uri, paramsData, function (data) {
                        window.location.href = data;
                        return data;
                    });
                } catch (e) {
                    console.error(e);
                }

                // return link;
            },
            /**
             * Create route params
             * @param   {string}    crud_type
             * @param   {object}    item
             * */
            createRoutePrams(crud_type, item) {

                let params = {
                    route: this.crud[crud_type].route
                };

                if ('params' in this.crud[crud_type]) {
                    params['params'] = {};
                    // console.log('createRoutePrams', 'item', item, ' this.crud[crud_type].params', this.crud[crud_type].params);

                    // search the params references
                    for (let i = 0; i < this.crud[crud_type].params.refs.length; i++) {
                        let paramsReference = this.crud[crud_type].params.refs[i];

                        params['params'][paramsReference] = item[paramsReference];
                    }
                }
                // console.log('createRoutePrams', 'params', params);
                return params;
            },
            crud_route_exists(crud_type) {
                // console.log('this.crud',this.crud);
                if (typeof this.crud !== 'undefined' && this.crud !== null) {
                    if (typeof this.crud[crud_type] !== 'undefined' && this.crud[crud_type] !== null) {
                        return true;
                    }
                }
                return false;
            },
            searchEvent(val) {
                this.search = val;
            },
            debug(s) {
                let args = Array.prototype.slice.call(arguments);

                // 2. Prepend log prefix log string
                // args.unshift(LOG_PREFIX + " ");

                // 3. Pass along arguments to console.log
                console.log.apply(console, args);
            },
            /**
             * sort the order for the type by rearringing the order on the others?
             * */
            formatType(first_item, second_item, sortKey, order) {

                //get the reference value
                let reference_first = first_item[this.types[sortKey].reference_field];
                let reference_second = second_item[this.types[sortKey].reference_field];
                // console.log('reference_first',reference_first);
                let calc = (
                        reference_first === reference_second ? 0 : reference_first > reference_second ? 1 : -1
                    ) *
                    order;
                // console.log('formatType',
                //     first_item,
                //     second_item,
                //     'this.types',this.types,
                //     'sortKey',sortKey,
                //     'reference_first',reference_first,
                //     'reference_second',reference_second,
                //     'calc',calc);
                return calc;
            },
            sortBy(key) {
                this.sortKey = key;
                let value = this.sortOrders[key],
                    value_to_toggle = 1;

                // is sorting ascending
                value_to_toggle = value > 0 ? -1 : value_to_toggle = value > -1 ? 1 : 0;

                // reset all previous positions
                this.sortOrders = _.mapObject(this.sortOrders, function (key) {
                    // console.log('mapObject(key)','key', key);
                    return 0;
                });
                //                console.log('sortBy', 'this.sortOrders',this.sortOrders);
                // console.log('sortBy', 'key', key, 'value_to_toggle', value_to_toggle, 'this.sortOrders', this.sortOrders);
                // set this one to the live status
                this.sortOrders[key] = value_to_toggle;

            },
            jsonCopy(src) {
                return JSON.parse(JSON.stringify(src));
            },
            sortData(data) {
                //                console.log('sortData', data);
                let sortKey = this.sortKey;

                if (_.isUndefined(sortKey) || sortKey == null) {
                    //                    console.error('sortData.isUndefined(sortKey)', sortKey);
                    return data;
                }

                // console.log('filteredItems', 'sortKey', sortKey, 'order', order, 'this.sortOrders', this.sortOrders);

                // console.log('_.isEmpty(_this.types)', _.isEmpty(_this.types));
                /**
                 * for re-ordering the table
                 */
                    // console.log('filteredItems', 'this.types',this.types);
                let order = this.sortOrders[sortKey];

                if (this.sortOrders[sortKey] == 0) {

                }
                // ascend
                else if (this.sortOrders[sortKey] > 0) {

                }
                // descend
                else {

                }

                let keyTypeData = this.types[sortKey];
                if (_.isUndefined(keyTypeData)) {
                    //                    console.error('sortData.isUndefined(keyTypeData)', 'sortKey', sortKey, 'this.types', this.types,'keyTypeData', keyTypeData);
                    return data;
                }
                //                console.log('sortData', 'keyTypeData', keyTypeData);
                //console.log('filteredItems', 'keyTypeData.type',keyTypeData.type);
                switch (keyTypeData.type) {
                    case 'money':
                        data = _.sortBy(data, function (record) {
                            // console.log('sortBy', 'record', record);
                            // get the money value
                            let money = parseFloat(record[sortKey]),
                                //convert to pennies and type cast to integer
                                pennies = parseInt(money * 100);
                            // console.log('sortKey', 'sortKey', sortKey, 'pennies', pennies);
                            data = sortKey[pennies];
                        }); // return ascending
                        break;

                    case 'date':
                        data = this.sortByTime(data, sortKey);
                        break;
                    case 'date_time':
                        data = this.sortByTime(data, sortKey);
                        break;
                    case 'json':
                    //                        return data;

                    default:
                        data = _.sortBy(data, sortKey); // return ascending
                    //                        console.log('sortData', 'default->_.sortBy(data, sortKey)', data);

                }

                if (order > 0) {
                    // console.log('filteredItems', 'keyTypeData.type', keyTypeData.type);
                    // console.log('filteredItems', 'up');
                } else if (order > -1) {
                    data = this.items; // return neutral
                    // console.log('filteredItems', 'neutral');
                } else {
                    data = data.reverse(); // return descending
                    // console.log('filteredItems', 'down');
                }

                // data = data.slice().sort(function (a, b) {
                //     // make sure the template types is defined
                //     if (!_.isEmpty(_this.types)) {
                //         return _this.formatType(a, b, sortKey, order);
                //     }
                //     else {
                //         a = a[sortKey];
                //         b = b[sortKey];
                //
                //         return (a === b ? 0 : a > b ? 1 : -1) * order;
                //     }
                // });
                return data;

            },
            sortByNumber(obj) {

            },
            sortByString() {

            },
            sortByTime(data, sortKey) {
                return _.sortBy(data, function (item) {
                    return new Date(item[sortKey]).getTime();
                });
            }
        },
        computed: {
            showFilter: function (key) {
                //types[key].active
            },
            filteredItems: function () {
                let _this = this;

                let search = (
                        this.search || ''
                    ).toLowerCase(),
                    data = this.jsonCopy(this.items); //return a copy
                //                console.log('_this.types', _this.types);

                /**
                 * the user has requested a search so lets do that here
                 */
                if (search !== '') {
                    //console.log('filteredItems', 'data', row);
                    data = data.filter(function (row) {
                        //console.log('filteredItems', 'row', row);
                        if ( row !== null ) {
                            return Object.keys(row).some(function (key) {
                                //console.log('', 'key',key);
                                let canFilterField = _this.canFilterField(key);
                                if (canFilterField == true) {
                                    return String(row[key]).toLowerCase().indexOf(search) > -1;
                                }

                            });
                        }
                    });
                    //                    return data;
                }
                //console.log('filteredItems', 'data',data);
                //                the user is requesting sorting
                let sorted_data = this.sortData(data);

                //                 console.log('filteredItems', 'sorted_data', sorted_data);
                return (
                    sorted_data != []
                ) ? sorted_data : data.splice(0, _this.display_limit);
            }
        },
        filters: {
            capitalize: function (str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            },
            lowercase: function (str) {
                return str.toLowerCase();
            }
        }
    };
</script>

<style scoped>
    .w-auto {
        display: block;
        width: 100%;
        height: 65vh;
        overflow-x: auto;
    }

    th {
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/tables/tableSearch.vue?64048274